import React, { useEffect, useState, useRef } from "react";
import { getRandomColor, createImageFromInitials } from "../Utils.js";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { AiOutlineCaretLeft, AiOutlineCaretRight } from "react-icons/ai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import DeleteIcon from "../../assets/images/trash.svg";
import DuplicateTaskIcon from "../../assets/images/duplicate_task.svg";
import { useDispatch, useSelector } from "react-redux";
import { postStrategyFunctions } from "../../store/actions/index.js";
import { StepProgressBar } from "../Utils.js";
import GoalSelector from "./GoalSelector.js";
import { resetExceptionError } from "../../store/actions/index.js";
import Alert from "../Alert.js";
import QuillEditor from "../../utils/QuillEditor.js";
import CommentSection from "./Comment";
import {
  postFolderManagerDelete,
  postLocalFolderManager,
  getLocalFolderManager,
  postLocalFolderManagerFileDelete,
  getXLExecutionPlanDetails,
} from "../../store/actions/index.js";
import { url } from "../../store/sagas/API.js";
import UploadImage from "../../assets/images/icon.svg";
import SheetImage from "../../assets/images/icons8-excel.svg";
import DocImage from "../../assets/images/icons8-microsoft-word.svg";
import PDFImage from "../../assets/images/pdf-svgrepo-com.svg";
import PPTImage from "../../assets/images/icons8-powerpoint.svg";
import TXTImage from "../../assets/images/icons8-text.svg";
import OtherImage from "../../assets/images/icons8-document.svg";
import NoDocImage from "../../assets/images/nodoc.svg";
import { motion } from "motion/react";
import DatePicker from "react-datepicker";
import { SlCalender } from "react-icons/sl";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
//import {getTaskDetails } from "../../store/actions/index.js";
import TaskUploadWindow from "./TaskUploadWindow";
import { FaFileImport } from "react-icons/fa6";



function XLExeuctionPlanSidebar({
  userPermission,
  userDueDatePermission,
  isEdit,
  workboard,
  data,
  type,
  placeholder,
  goalData,
  empData,
  parentId,
  statusData,
  priorityData,
  breadcrumbs,
  functionIndex,
  impIndex,
  impid,
  milestoneIndex,
  handleMilestoneEdit,
  handleStrategicImpEdit,
  onClose,
  setIsSidebarOpen,
  handleStrategicImpDelete,
  handleMilestoneDelete,
  milestonedataId,
  handleDuplicateTaskClick,
  handleDTPopupShow,
  functionItemName = "",
  simpItemName = "",
}) {
  const dispatch = useDispatch();
  const ISError = useSelector((state) => state.ISError);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const loggedInUserPermission = data?.user_permission;
  const [title, setTitle] = useState(isEdit ? data.name : "");
  const [progressHide, setProgressHide] = useState(false);
  const textareaRef = useRef(null);
  const postStrategyFunctionDetails = useSelector(
    (state) => state.postStrategyFunctionDetails
  );
  const [assignedTo, setAssignedTo] = useState(
    isEdit ? data.assigned_to?.filter((employee) => employee.is_active) : []
  );
  const [selectedGoals, setSelectedGoals] = useState(
    isEdit && type !== "milestone"
      ? data?.goals_dt?.filter((goal) => goal.is_active)
      : []
  );
  const selectedSubMenuPermission = useSelector(
    (state) => state.selectedSubMenuPermission
  );
  const [progress, setProgress] = useState(isEdit ? data.progress : 0);
  const [desc, setDesc] = useState(isEdit ? data.description : "");
  const [status, setStatus] = useState(
    isEdit
      ? { label: data.status, value: data.status }
      : { label: "Open", value: "Open" }
  );
  const [priority, setPriority] = useState(
    isEdit ? { label: data.priority, value: data.priority } : ""
  );
  const [startDate, setstartDate] = useState(isEdit ? data.start_date : "");
  const [duedate, setDuedate] = useState(isEdit ? data.due_date : "");
  const initialCollaborators =
    isEdit && data.collaberators
      ? data.collaberators?.filter((employee) => employee.is_active)
      : [];
  const [collaberators, setCollaberators] = useState(initialCollaborators);
  const [showMilestoneUploadFile, setShowMilestoneUploadFile] = useState(false);
  const [showImpUploadFile, setShowImpUploadFile] = useState(false);
  const [shownewUploadFile, setShowNewUploadFile] = useState(false);
  const [showNewUploadFileTaskId, setShowNewUploadFileTaskId] = useState(false);
 // const [taskSaved,setTaskSaved]=useState({});
 
 //const getSingleTaskDetails = useSelector((state) => state.getSingleTaskDetails);

  const [taskUploadWindow, setTaskUploadWindow] = useState(false);

  let user_emp = null;

  try {
    user_emp = JSON.parse(localStorage.getItem("userDetails"));
  } catch (e) {
    console.error("Invalid JSON in localStorage");
  }

  const currentUser = user_emp?.data?.emp_id;


 const [taskComments, setTaskComments] = useState([]);

  const [milestoneId, setMilestoneId] = useState(
    isEdit && type === "milestone" ? data.id : ""
  );
  const [functionalGoalId, setFunctionalGoalId] = useState(
    isEdit && type !== "milestone" ? data.id : ""
  );
  const [fullScreenMode, setFullScreenMode] = useState(false);
  useEffect(() => {
    if (impid) {
      setShowImpUploadFile(true);
      setShowMilestoneUploadFile(false);
    }
  }, [impid]);
/*useEffect(() => {// without this we cant fetch the comments data and when we give comment we cant able to edit or delete it and name will mention
  if (data.id) {
    dispatch(getTaskDetails(data.id));
  
  }
}, [data.id]);

useEffect(() => {
    if (
      isEdit &&
      getSingleTaskDetails &&
      getSingleTaskDetails.message &&
      getSingleTaskDetails.message.length > 0
    ) {
      setCurrentUser(getSingleTaskDetails?.message[0]?.emp_id);
      setTaskComments(
        getSingleTaskDetails.message[0].comments.map((item) => ({
          ...item,
          icon: createImageFromInitials(
            30,
            item.comment_by[0].name,
            getRandomColor(item.comment_by[0].name)
          ),
        }))
      );
    }
  }, [getSingleTaskDetails]);*/

  useEffect(() => {
    if (milestonedataId) {
      setShowMilestoneUploadFile(true);
      setShowImpUploadFile(false);
    }
  }, [milestonedataId]);
  useEffect(() => {
    if (postStrategyFunctionDetails && !isEdit) {
      if (postStrategyFunctionDetails.response) {
        setShowNewUploadFileTaskId(postStrategyFunctionDetails.response[0].key);
        setShowNewUploadFile(true);
      }
    }
   // setTaskSaved(postStrategyFunctionDetails)
  }, [postStrategyFunctionDetails]);
  useEffect(() => {
    if (!data.name) {
      setShowNewUploadFile(false);
    }
  }, []);
  const getProgress = (step) => {
    if (step === 0) {
      return 0;
    } else if (step === 20) {
      return 1;
    } else if (step === 40) {
      return 2;
    } else if (step === 60) {
      return 3;
    } else if (step === 80) {
      return 4;
    } else {
      return 5;
    }
  };
  const [currentStep, setCurrentStep] = useState(
    isEdit ? getProgress(data.progress) : 0
  );
  const steps = ["Step 1", "Step 2", "Step 3", "Step 4", "Step 5", "Step 6"];

  const customStyles = (borderStyle) => ({
    control: (provided, state) => ({
      ...provided,
      ...borderStyle,
      borderRadius: "10px",
      marginBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      zIndex: 99999,
      backgroundColor: state.isSelected ? "#ecf4f3" : "white",
      color: "black",
    }),
  });

  const customFilter = (option, searchText) => {
    if (option.data.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };
  const resizeTextarea = (e) => {
    e.target.style.height = "auto"; // Reset height
    e.target.style.height = `${e.target.scrollHeight}px`; // Set to scroll height
  };

  // Trigger resize when component mounts (for existing data)
  useEffect(() => {
    if (textareaRef.current) {
      resizeTextarea({ target: textareaRef.current });
    }
  }, [title]);
  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl.includes("strategyplan")) {
      setProgressHide(true);
    } else {
      setProgressHide(false);
    }
  }, []);

  const addComment = (newComment) => {
    setTaskComments([...taskComments, newComment]);
  };

  const handleEditComment = (name, newContent) => {
    const updatedComments = taskComments.map((comment) =>
      comment.name === name ? { ...comment, content: newContent } : comment
    );
    setTaskComments(updatedComments);
  };

  const handleDeleteComment = (name) => {
    const updatedComments = taskComments.filter((comment) => comment.name !== name);
    setTaskComments(updatedComments);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "s") {
        event.preventDefault();
        if (
          (!workboard && userPermission === "write") ||
          loggedInUserPermission === "write"
        ) {
          handleSave();
        }
      }

      if (event.key === "Escape") {
        event.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    title,
    assignedTo,
    status,
    startDate,
    duedate,
    priority,
    selectedGoals,
    progress,
    desc,
  ]);
  const handleOwnerChange = (e) => {
    setAssignedTo(e);
  };
  const handleCollaboratorChange = (e) => {
    setCollaberators(e);
  };

  const handleFullScreen = () => {
    setFullScreenMode(true);
  };

  const handleSideNav = () => {
    setFullScreenMode(false);
  };

  const handleStatusSelect = (selectedOptions) => {
    setStatus(selectedOptions);
  };

  const handlePrioritySelect = (selectedOptions) => {
    setPriority(selectedOptions);
  };

  const handleMenuClick = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleDescOnChange = (content) => {
    setDesc(content);
  };

  const handleSave = () => {
    if (
      selectedSubMenuPermission === "write" ||
      selectedSubMenuPermission === "admin"
    ) {
      if (type === "milestone") {
        if (title !== "") {
          if (isEdit) {
            // setIsSidebarOpen(false);
            let assignedToList = [];
            if (Array.isArray(assignedTo)) {
              assignedToList = assignedTo;
            } else {
              assignedToList = [assignedTo];
            }
            const requiredAssignedData = empData.map((item) => ({
              key: item.value,
              is_active: assignedToList.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const updatedAssignedData = empData.map((item) => ({
              ...item,
              is_active: assignedToList.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const requiredCollaboratorsData = empData.map((item) => ({
              key: item.value,
              is_active: collaberators.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));

            let milestone_data = [
              {
                bi_id: localStorage.getItem("bi_id"),
                milestone: title,
                milestone_id: milestoneId,
                prod_id: localStorage.getItem("product_id"),
                status: status.value,
                start_date: startDate || "",
                due_date: duedate || "",
                priority: priority.value,
                assigned_to: requiredAssignedData,
                progress: progress,
                description: desc,
                collaberators: requiredCollaboratorsData,
                is_active: true,
              },
            ];

            handleMilestoneEdit(
              functionIndex,
              impIndex,
              milestoneIndex,
              milestone_data,
              updatedAssignedData
            );
          } else {
            const assignedToList = [assignedTo];
            const requiredAssignedData = empData.map((item) => ({
              key: item.value,
              is_active: assignedToList.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const requiredCollaboratorsData = empData.map((item) => ({
              key: item.value,
              is_active: collaberators.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));

            let milestone_data = [
              {
                bi_id: localStorage.getItem("bi_id"),
                prod_id: localStorage.getItem("product_id"),
                imperative_id: parentId,
                milestone: title,
                milestone_id: isEdit ? milestoneId : false,
                status: status.value || "",
                start_date: startDate || "",
                due_date: duedate,
                priority: priority.value || "",
                assigned_to: requiredAssignedData,
                progress: progress,
                description: desc,
                collaberators: requiredCollaboratorsData,
                is_active: true,
              },
            ];
            dispatch(
              postStrategyFunctions(
                milestone_data,
                "milestone",
                false,
                false,
                true
              )
            );
          }
        } else {
          Alert.warning({
            title: "Warning",
            text: "Milestone name should not be empty",
            html: ISError,
            icon: "warning",
            preConfirm: (isConfirm) => {
              if (isConfirm) {
                dispatch(resetExceptionError());
              } else {
              }
            },
          });
        }
      } else {
        if (title !== "") {
          if (isEdit) {
            // setIsSidebarOpen(false);
            let assignedToList = [];
            if (Array.isArray(assignedTo)) {
              assignedToList = assignedTo;
            } else {
              assignedToList = [assignedTo];
            }
            const requiredAssignedData = empData.map((item) => ({
              key: item.value,
              is_active: assignedToList.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const updatedAssignedData = empData.map((item) => ({
              ...item,
              is_active: assignedToList.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const selectedGoalsWithActive = data.goals_dt.map((goal) => ({
              key: goal.value,
              is_active: selectedGoals.some(
                (selectedGoal) => selectedGoal.value === goal.value
              ),
            }));
            const updatedGoalsData = data.goals_dt.map((goal) => ({
              ...goal,
              is_active: selectedGoals.some(
                (selectedGoal) => selectedGoal.value === goal.value
              ),
            }));
            const requiredCollaboratorsData = empData.map((item) => ({
              key: item.value,
              is_active: collaberators.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const updatedCollaboratorsData = empData.map((item) => ({
              ...item,
              is_active: collaberators.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            let functional_goal_data = [
              {
                bi_id: localStorage.getItem("bi_id"),
                product_id: localStorage.getItem("product_id"),
                function_id: parentId,
                imperative_name: title,
                imperative_id: isEdit ? functionalGoalId : false,
                selected_goal: selectedGoalsWithActive,
                status: status.value || "Open",
                start_date: startDate || "",
                due_date: duedate,
                priority: priority.value || "",
                assigned_to: requiredAssignedData,
                progress: progress,
                description: desc,
                collaberators: requiredCollaboratorsData,
                is_active: true,
              },
            ];
            handleStrategicImpEdit(
              functionIndex,
              impIndex,
              functional_goal_data,
              updatedAssignedData,
              updatedGoalsData,
              updatedCollaboratorsData
            );
          } else {
            const assignedToList = [assignedTo];
            const requiredAssignedData = empData.map((item) => ({
              key: item.value,
              is_active: assignedToList.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            const selectedGoalsWithActive = goalData.map((goal) => ({
              key: goal.value,
              is_active: selectedGoals.some(
                (selectedGoal) => selectedGoal.value === goal.value
              ),
            }));
            const requiredCollaboratorsData = empData.map((item) => ({
              key: item.value,
              is_active: collaberators.some(
                (selectedItem) => selectedItem.value === item.value
              ),
            }));
            let functional_goal_data = [
              {
                bi_id: localStorage.getItem("bi_id"),
                product_id: localStorage.getItem("product_id"),
                function_id: parentId,
                imperative_name: title,
                imperative_id: isEdit ? functionalGoalId : false,
                selected_goal: selectedGoalsWithActive,
                status: status.value || "Open",
                start_date: startDate || "",
                due_date: duedate,
                priority: priority.value || "",
                assigned_to: requiredAssignedData,
                progress: progress,
                description: desc,
                collaberators: requiredCollaboratorsData,
                is_active: true,
              },
            ];
            dispatch(
              postStrategyFunctions(
                functional_goal_data,
                "functional_goal",
                false,
                true
              )
            );
          }
        } else {
          Alert.warning({
            title: "Warning",
            text: "Functional Goal name should not be empty",
            html: ISError,
            icon: "warning",
            preConfirm: (isConfirm) => {
              if (isConfirm) {
                dispatch(resetExceptionError());
              } else {
              }
            },
          });
        }
      }
      // setIsSidebarOpen(false);
    }
    // setShowNewUploadFile(true)
  };
  const logo = createImageFromInitials(
    30,
    localStorage.getItem("full_name"),
    getRandomColor(localStorage.getItem("full_name"))
  );

  const handleStepClick = (stepIndex) => {
    setCurrentStep(stepIndex);
    setProgress(stepIndex * 20);
  };

  const handleGoalChange = (selectedOptions) => {
    setSelectedGoals(selectedOptions);
  };
  return (
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 1 }}
      exit={{ x: "100%" }}
      style={{
        width: fullScreenMode && "calc(100% - 50px)",
        zIndex: "100",
      }}
      className={"sidenav"}
    >
      <div
        className="gtm-sidebar-header"
        style={{
          borderBottom: "1px solid lightgrey",
          alignItems: "center",
        }}
      >
        <div
          style={{
            flex: "1",
            maxWidth: "70%",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            margin: "0",
            paddingTop: "4px",
            fontSize: "var(--sub-heading-font-size)",
            fontWeight: "var(--heading-font-weight)",
            paddingLeft: "10px",
            justifyContent: "center",
          }}
          title={breadcrumbs}
        >
          {breadcrumbs}
        </div>

        {isEdit &&
            (selectedSubMenuPermission === "write" ||
              selectedSubMenuPermission === "admin") &&
              userPermission === "write" &&
              (
              <a
                className="bulk-add-btn"
                href="#"
                onClick={() => {
                  setTaskUploadWindow(true);
                  setFullScreenMode(true);
                }}
              >
                {/* Bulk Add {type === "milestone" ? "Tasks" : "Milestones"} */}
                <FaFileImport size={18}/>
                
              </a>
            )}

        {userPermission === "write" &&
          (selectedSubMenuPermission === "write" ||
            selectedSubMenuPermission === "admin") &&
          isEdit && (
            <a href="#" className="sideMenu" onClick={handleMenuClick}>
              <FontAwesomeIcon icon={faEllipsisH} />
            </a>
          )}
        {isMenuOpen && (
          <>
            {type === "milestone" ? (
              <div className="menu">
                <div className="delete-xlexecution-plan">
                  {(selectedSubMenuPermission === "write" ||
                    selectedSubMenuPermission === "admin") && (
                    <div
                      className="delete-option-xlexecution-plan"
                      onClick={() => {
                        handleMilestoneDelete(
                          functionIndex,
                          impIndex,
                          milestoneIndex,
                          milestonedataId
                        );
                        onClose();
                      }}
                    >
                      <img
                        src={DeleteIcon}
                        width="18px"
                        style={{ marginRight: "10px" }}
                        alt="delete icon"
                      />
                      Delete
                    </div>
                  )}
                </div>
                <div style={{ cursor: "pointer" }}>
                  <div
                    className="duplicate-option-xlexecution-plan"
                    onClick={() => {
                      handleDuplicateTaskClick(milestonedataId, title);
                      onClose();
                      handleDTPopupShow();
                    }}
                  >
                    <img
                      src={DuplicateTaskIcon}
                      width="16px"
                      style={{ marginRight: "10px" }}
                      alt="duplicate task icon"
                    />
                    Duplicate Task
                  </div>
                </div>
              </div>
            ) : (
              (selectedSubMenuPermission === "write" ||
                selectedSubMenuPermission === "admin") && (
                <div className="menu">
                  <div className="Edit">
                    <div
                      className="DeleteOption"
                      onClick={() => {
                        handleStrategicImpDelete(
                          functionIndex,
                          impIndex,
                          impid
                        );
                        onClose();
                      }}
                    >
                      <img
                        src={DeleteIcon}
                        width="18px"
                        style={{ marginRight: "10px" }}
                        alt="delete icon"
                      />
                      Delete
                    </div>
                  </div>
                </div>
              )
            )}
          </>
        )}

        {!fullScreenMode ? (
          <a href="#" className="fullscreen" onClick={handleFullScreen}>
            <AiOutlineCaretRight />
          </a>
        ) : (
          <a href="#" className="fullscreen" onClick={handleSideNav}>
            <AiOutlineCaretLeft />
          </a>
        )}

        <a href="#" className="closebtn" onClick={onClose}>
          &times;
        </a>
      </div>
      <div className="gtm-sidebar-body">
        <div>
          <textarea
            ref={textareaRef}
            className="form-control"
            placeholder={placeholder}
            required
            value={title}
            rows={1}
            style={{
              padding: "6px 8px",
              marginLeft: "10px",
              width: "99%",
              border: "1px solid #ccc",
              borderRadius: "4px",
              marginBottom: "10px",
              fontSize: "var(--task-title-font-size)",
              resize: "none",
              overflow: "hidden",
              lineHeight: "1.5",
            }}
            onInput={resizeTextarea} // Resize while typing
            onChange={(e) => {
              setTitle(e.target.value.slice(0,140));
            }}
            disabled={
              (!workboard && userPermission === "write") ||
              (workboard && loggedInUserPermission === "write")
                ? false
                : true
            }
          />
        </div>

        <div className="row">
          <div
            className="col-6"
            style={{
              alignItems: "center",
              marginBottom: "10px",
              zIndex: 888,
            }}
          >
            <div
              style={{
                marginLeft: "10px",
                marginRight: "20px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Owner
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Select
                required
                name="emp_id"
                styles={customStyles}
                placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select Owner
                  </span>
                }
                value={assignedTo}
                options={empData}
                onChange={handleOwnerChange}
                isSearchable={true}
                filterOption={customFilter}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img alt="" src={e.icon} />
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--text-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                isDisabled={
                  (!workboard && userPermission === "write") ||
                  (workboard && loggedInUserPermission === "write")
                    ? false
                    : true
                }
              />
            </div>
          </div>

          <div
            className="col-6"
            style={{
              // display: type === "milestone" ? "block" : "none",
              alignItems: "center",
              marginBottom: "10px",
              // zIndex: 999,
            }}
          >
            <div
              style={{
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Status
            </div>
            <Select
              required
              styles={customStyles}
              placeholder={
                <span style={{ fontSize: "var(--text-font-size)" }}>
                  Select Status
                </span>
              }
              value={status}
              options={statusData}
              onChange={handleStatusSelect}
              isSearchable={true}
              filterOption={customFilter}
              getOptionLabel={(e) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      marginLeft: 5,
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                  >
                    {e.label}
                  </span>
                </div>
              )}
              isDisabled={
                (!workboard && userPermission === "write") ||
                (workboard && loggedInUserPermission === "write")
                  ? false
                  : true
              }
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-6"
            style={{
              // display: type === "milestone" ? "block" : "none",
              alignItems: "center",
            }}
          >
            <span
              style={{
                marginLeft: "10px",
                marginBottom: "10px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
                whiteSpace: "nowrap",
              }}
            >
              Start Date
            </span>
            {/* Container for DatePicker with slight left margin and relative positioning(used to position calendar icon properly) */}
             <div style={{ marginLeft: "10px", width: "98%", position: "relative" }}  >
              <DatePicker
                selected={startDate ? new Date(startDate) : null} // Convert stored string (YYYY-MM-DD) → JS Date object for DatePicker
                  // When user selects/clears date:
                 // Convert Date → string (YYYY-MM-DD) and update state
                onChange={(d) => setstartDate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                dateFormat="yyyy-MM-dd" // Display format inside input
                placeholderText="YYYY-MM-DD" // Placeholder when no date is selected
                portalId="root"  // Renders calendar popup at root level to avoid overflow/clipping issues
                wrapperClassName="w-100" // Makes DatePicker take full width
                showMonthDropdown  // Enable dropdowns for better UX (month & year selection)
                showYearDropdown
                dropdownMode="select"
                popperProps={{ strategy: "fixed" }}
                popperPlacement="bottom-start"
                popperClassName="custom-popper"
               customInput={  // Custom input field instead of default DatePicker input
                  <input className="form-control"
                   style={{
               width: "100%",
                fontSize: "var(--sub-heading-font-size)",
              }} 
                    readOnly
                  />}
                 disabled={  // Enable/disable input based on permissions
                (!workboard && userPermission === "write") ||
                (workboard && loggedInUserPermission === "write")
                  ? false
                  : true
              } />
              <SlCalender size={14} color={startDate ? "#28a745" : "gray"} style={{ position: "absolute", right: "12px", top: "40%", transform: "translateY(-50%)", pointerEvents: "none", }}
              /></div>
          </div>
          <div
            className="col-6"
            style={{
              // display: type === "milestone" ? "block" : "none",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
                whiteSpace: "nowrap",
              }}
            >
              Due Date
            </div>
            <div style={{ marginLeft: "1px", width: "100%", position: "relative" }}>
              <DatePicker
               selected={duedate ? new Date(duedate) : null}
               onChange={(d) => setDuedate(d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split("T")[0] : "")}
                dateFormat="yyyy-MM-dd"
                placeholderText="YYYY-MM-DD"
                wrapperClassName="w-100"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                popperProps={{
                  strategy: "fixed"
                }}
                portalId="root"
                popperPlacement="bottom-start"
                popperClassName="custom-popper"
                customInput={
                <input className="form-control"
                style={{
                width: "100%",
                fontSize: "var(--sub-heading-font-size)",
              }}
                    readOnly 
                    />
                  }
                disabled={
                (!workboard &&
                  userPermission === "write" &&
                  (!isEdit || userDueDatePermission === "write")) ||
                (workboard &&
                  loggedInUserPermission === "write" &&
                  userDueDatePermission === "write")
                  ? false
                  : true
              } />
              <SlCalender size={14} color={duedate ? "#28a745" : "gray"} style={{ position: "absolute", right: "12px", top: "40%", transform: "translateY(-50%)", pointerEvents: "none", }}
              /></div>
           
          </div>
        </div>

        <div
          className="row"
          // style={{ display: type === "milestone" ? "block" : "none" }}
        >
          <div
            className="col-6"
            style={{
              alignItems: "center",
              marginBottom: "20px",
              zIndex: 777,
            }}
          >
            <div
              style={{
                marginLeft: "10px",
                marginRight: "40px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Priority
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Select
                required
                styles={customStyles}
                placeholder={
                  <span style={{ fontSize: "var(--text-font-size)" }}>
                    Select priority
                  </span>
                }
                value={priority}
                options={priorityData}
                onChange={handlePrioritySelect}
                isSearchable={true}
                filterOption={customFilter}
                getOptionLabel={(e) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span
                      style={{
                        marginLeft: 5,
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                isDisabled={
                  (!workboard && userPermission === "write") ||
                  (workboard && loggedInUserPermission === "write")
                    ? false
                    : true
                }
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-12"
            style={{
              display: type === "functional_goal" ? "block" : "none",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                marginLeft: "10px",
                marginRight: "50px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
              }}
            >
              Goals
            </div>
            <div style={{ marginLeft: "10px" }}>
              <GoalSelector
                selectedGoals={selectedGoals}
                options={goalData}
                value={selectedGoals}
                handleGoalChange={handleGoalChange}
                disabled={
                  (!workboard && userPermission === "write") ||
                  (workboard && loggedInUserPermission === "write")
                    ? false
                    : true
                }
              />
            </div>
          </div>
        </div>
        {!progressHide && (
          <div className="row">
            <div
              className="col-12"
              style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <h6
                style={{
                  marginLeft: "10px",
                  marginRight: "20px",
                  marginBottom: 0,
                  fontWeight: "var(--heading-font-weight)",
                }}
              >
                Progress
              </h6>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  marginLeft: "15px",
                  marginRight: "10px",
                  zIndex: 0,
                }}
              >
                <StepProgressBar
                  steps={steps}
                  currentStep={currentStep}
                  onStepClick={handleStepClick}
                  selectedSubMenuPermission={
                    !workboard ? userPermission : loggedInUserPermission
                  }
                />
                <div className="step-percentage">
                  {(currentStep / (steps.length - 1)) * 100}%
                </div>
              </div>
            </div>
          </div>
        )}

        {type === "milestone" && simpItemName && (

          <div>
            <div
              style={{
                marginBottom: "0px",
                fontSize: "var(--sub-heading-font-size)",
                fontWeight: "var(--heading-font-weight)",
                marginLeft: "10px",
              }}
            >
              Functional Goal
            </div>
            <div
              style={{
                marginLeft: "10px",
                marginRight: "20px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "6px 8px",
                margin: "10px 10px 10px 10px",  
                fontSize: "var(--text-font-size)",
                backgroundColor: "#eeeeee",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                // fontWeight: "var(--heading-font-weight)",
              }}
            >
              <span>{simpItemName || breadcrumbs } </span>
            </div>

          </div>

        

        ) }

        <div
          style={{
            marginBottom: "0px",
            fontSize: "var(--sub-heading-font-size)",
            fontWeight: "var(--heading-font-weight)",
            marginLeft: "10px",
          }}
        >
          Description
        </div>
        <div style={{ margin: "10px 10px 10px 10px", height: "350px" }}>
          <QuillEditor
            value={desc}
            onChange={handleDescOnChange}
            height={"350px"}
            disabled={
              (!workboard && userPermission === "write") ||
              (workboard && loggedInUserPermission === "write")
                ? false
                : true
            }
          />
        </div>
        <br />
        {/* <div style={{ display: "flex", width: "100%" }}>
          <h6
            style={{
              marginLeft: "20px",
              marginBottom: "0px",
              display: "flex",
              alignItems: "center",
              paddingRight: "10px",
            }}
          >
            Collaborators
          </h6>

          <Select
            required
            name="emp_id"
            isMulti
            className="select-collaborator"
            hideSelectedOptions
            allowSelectAll
            styles={customStyles}
            filterOption={customFilter}
            placeholder="Select"
            value={collaberators}
            options={empData}
            onChange={handleCollaboratorChange}
            isSearchable={true}
            getOptionLabel={(e) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img alt="" src={e.icon} />
                <span style={{ marginLeft: 5 }}>{e.label}</span>
              </div>
            )}
            menuPlacement="top"
            isDisabled={
                  (!workboard && userPermission === "write") ||
                  (workboard && loggedInUserPermission === "write")
                    ? false
                    : true
                }
          />
        </div> */}
        {showImpUploadFile && isEdit ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={
                !workboard ? userPermission : loggedInUserPermission
              }
              taskId={impid}
              attachments={isEdit ? data.attachments : ""}
              isEdit={isEdit}
            />
          </>
        ) : showMilestoneUploadFile && isEdit ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={
                !workboard ? userPermission : loggedInUserPermission
              }
              taskId={milestonedataId}
              attachments={isEdit ? data.attachments : ""}
              isEdit={isEdit}
            />
          </>
        ) : shownewUploadFile && !isEdit ? (
          <>
            <div
              style={{
                fontSize: "var(--text-font-size)",
                fontWeight: "var(--heading-font-weight)",
                paddingLeft: "10px",
              }}
            >
              Please Upload relevant documents
            </div>
            <UploadFiles
              selectedSubMenuPermission={
                !workboard ? userPermission : loggedInUserPermission
              }
              taskId={showNewUploadFileTaskId}
              isEdit={isEdit}
            />
          </>
        ) : null}
          {isEdit  && (
          <div style={{ marginTop: "20px", padding: "0 10px" }}>
            <CommentSection
              key={data.id}
              currentUser={currentUser}
              logo={logo}
              fullScreenMode={fullScreenMode}
              taskId={data.id} 
              commentsData={taskComments}
              onAddComment={addComment}
              onEditComment={handleEditComment}
              onDeleteComment={handleDeleteComment}
            />
          </div>
        )}
      </div>
      <div>
        <div>
          <Button
            type="button"
            style={{
              position: "absolute",
              top: "8px",
              right: "180px",
              padding: "4px 10px",
              backgroundColor: "var(--button-primary-color)",
              fontSize: "var(--sub-heading-font-size)",
              border: "1px solid var(--button-primary-color)",
            }}
            onClick={() => {
              if (
                (!workboard && userPermission === "write") ||
                loggedInUserPermission === "write"
              ) {
                handleSave();
              }
            }}
            disabled={
              (!workboard && userPermission === "write") ||
              (workboard && loggedInUserPermission === "write")
                ? false
                : true
            }
          >
            Save
          </Button>

          
        </div>

        {taskUploadWindow && (
          <TaskUploadWindow
            parentTaskName={data.id}
            parentSubject={title}
            childLabel={type === "milestone" ? "Task" : "Milestone"}
            onClose={() => setTaskUploadWindow(false)}
            onImported={() => window.location.reload()}
            setFullScreenMode = {setFullScreenMode}
          />
        )}
      </div>
    </motion.div>
  );
}

const UploadFiles = ({
  selectedSubMenuPermission,
  attachments,
  taskId,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [files, setFiles] = useState([]);

  const fetchpostLocalManagerData = useSelector(
    (state) => state.fetchpostLocalManagerData
  );
  const fetchpostLocalFolderManagerFileDelete = useSelector(
    (state) => state.fetchpostLocalFolderManagerFileDelete
  );

  useEffect(() => {
    if (attachments && taskId) {
      setFiles(attachments);
    }
  }, [attachments]);

  useEffect(() => {
    if (fetchpostLocalManagerData && fetchpostLocalManagerData.status === 200) {
      if (fetchpostLocalManagerData.message) {
        const attachedToNames = fetchpostLocalManagerData.message.map(
          (item) => item.attached_to_name
        );
        if (attachedToNames.includes(taskId)) {
          setFiles((prevFiles) => [
            ...prevFiles,
            ...fetchpostLocalManagerData.message,
          ]);
        }
      }
    }
  }, [fetchpostLocalManagerData]);

  useEffect(() => {
    if (
      fetchpostLocalFolderManagerFileDelete &&
      fetchpostLocalFolderManagerFileDelete.status === 200
    ) {
      if (isEdit) {
        setFiles((prevFiles) => {
          const updatedFiles = prevFiles?.filter(
            (existingItem) =>
              !fetchpostLocalFolderManagerFileDelete.file_id.includes(
                existingItem.name
              )
          );
          return updatedFiles;
        });
      }
    }
  }, [fetchpostLocalFolderManagerFileDelete]);

  const handleDeleteFile = (id) => {
    Alert.warning({
      title: "Warning",
      // html: ISError,
      text: "Are you sure do you want to delete the File?",
      icon: "warning",
      showCancelButton: true,
      preConfirm: (isConfirm) => {
        if (isConfirm) {
          dispatch(postLocalFolderManagerFileDelete(id));
          dispatch(resetExceptionError());
        }
      },
    });
  };

  const onButtonClick = () => {
    inputRef.current.click();
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files);
    }
  };
  const [isMSDocsSend, setIsMSDocsSend] = useState(false);

  function handleFile(files) {
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      setIsMSDocsSend(!isMSDocsSend);
      if (taskId) {
        dispatch(
          postLocalFolderManager(
            localStorage.getItem("bi_id"),
            localStorage.getItem("screen_id"),
            localStorage.getItem("main_screen_id"),
            file,
            "",
            "",
            localStorage.getItem("product_id"),
            taskId
          )
        );
      }
    }
  }
  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files);
    }
  };

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  return (
    <div>
      <div className="row">
        <div>
          <form
            id="form-file-upload"
            onDragEnter={
              selectedSubMenuPermission === "write" ||
              selectedSubMenuPermission === "admin"
                ? handleDrag
                : null
            }
            onSubmit={(e) => e.preventDefault()}
            style={{
              height: "60px",
              width: "80%",
              margin: "auto",
              marginBottom: "20px",
              marginTop: "10px",
            }}
          >
            <input
              ref={inputRef}
              type="file"
              id="input-file-upload"
              multiple={true}
              onChange={handleChange}
              disabled={
                selectedSubMenuPermission === "write" ||
                selectedSubMenuPermission === "admin"
                  ? false
                  : true
              }
            />
            <label
              id="label-file-upload"
              htmlFor="input-file-upload"
              className={dragActive ? "drag-active" : ""}
            >
              <div>
                <button
                  className="upload-button"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default form submission
                    onButtonClick();
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor:
                      selectedSubMenuPermission === "write" ||
                      selectedSubMenuPermission === "admin"
                        ? "pointer"
                        : "default",
                    textDecoration:
                      selectedSubMenuPermission === "write" ||
                      selectedSubMenuPermission === "admin"
                        ? ""
                        : "none",
                  }}
                >
                  <div>
                    <img src={UploadImage} />
                  </div>
                  <span
                    style={{
                      color: "#0DA14B",
                      marginLeft: "5px",
                      fontSize: "var(--sub-heading-font-size)",
                      fontWeight: "var(--heading-font-weight)",
                    }}
                  >
                    Upload a file
                  </span>
                  <span
                    style={{
                      paddingLeft: "10px",
                      fontSize: "var(--sub-heading-font-size)",
                    }}
                  >
                    or drag and drop a file
                  </span>
                </button>
              </div>
            </label>
            {dragActive && (
              <div
                id="drag-file-element"
                onDragEnter={handleDrag}
                onDragLeave={handleDrag}
                onDragOver={handleDrag}
                onDrop={handleDrop}
              ></div>
            )}
          </form>
          <div>
            {files.length > 0 ? (
              <>
                <table className="bordered-table-upload-files">
                  <thead
                    style={{
                      backgroundColor: "#F6F8FA",
                    }}
                  >
                    <tr>
                      <th>File</th>
                      <th>Modified</th>
                      <th>Modified By</th>
                      {selectedSubMenuPermission === "write" && <th>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {files.length > 0 &&
                      files.map((obj) => (
                        <tr key={obj.name}>
                          <td style={{ textAlign: "left" }}>
                            <a
                              href={url + obj.file_url}
                              target="_blank"
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                              }}
                            >
                              <img
                                src={
                                  obj.img
                                    ? url + obj.img
                                    : obj.file_name.split(".").pop() ===
                                        "xls" ||
                                      obj.file_name.split(".").pop() ===
                                        "xlsx" ||
                                      obj.file_name.split(".").pop() === "csv"
                                    ? SheetImage
                                    : obj.file_name.split(".").pop() === "pdf"
                                    ? PDFImage
                                    : obj.file_name.split(".").pop() ===
                                        "doc" ||
                                      obj.file_name.split(".").pop() === "docx"
                                    ? DocImage
                                    : obj.file_name.split(".").pop() === "ppt"
                                    ? PPTImage
                                    : OtherImage
                                }
                                style={{
                                  width: 25,
                                  height: 25,
                                }}
                              />
                              <label
                                style={{
                                  color: "black",
                                  cursor: "pointer",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  fontSize: "var(--text-font-size)",
                                  width: "300px",
                                }}
                              >
                                {obj.file_name}
                              </label>
                            </a>
                          </td>
                          <td style={{ fontSize: "var(--text-font-size)" }}>
                            {obj.modified}
                          </td>
                          <td style={{ fontSize: "var(--text-font-size)" }}>
                            {obj.modified_by}
                          </td>
                          {selectedSubMenuPermission === "write" && (
                            <td>
                              <span
                                className="folder-managementicons"
                                title="Delete"
                                onClick={() => handleDeleteFile(obj.name)}
                              >
                                <img src={DeleteIcon} width={14} />
                              </span>
                            </td>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            ) : (
              <>
                <label
                  style={{
                    fontSize: "var(--sub-heading-font-size)",
                    fontWeight: "var(--heading-font-weight)",
                    marginLeft: "10px",
                  }}
                >
                  All Documents
                </label>
                <div style={{ textAlign: "center" }}>
                  <img src={NoDocImage} />
                  <div>
                    <label
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                        fontWeight: "var(--heading-font-weight)",
                      }}
                    >
                      No Documents
                    </label>
                  </div>
                  <div>
                    <label
                      style={{
                        fontSize: "var(--sub-heading-font-size)",
                      }}
                    >
                      Uploaded documents will appear here
                    </label>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default XLExeuctionPlanSidebar;
